import { z } from '@/libs/zod';
import { isValidPhone } from '@/utils';
import { parseDigits, removeDDIFromAutoInsert } from '@/utils/formatters';

export const recoveryPhoneSchema = z
  .object({
    newPhone: z.string().trim().min(1, 'Novo telefone é obrigatório'),
    confirmNewPhone: z.string().trim().min(1, 'Confirmação de telefone é obrigatória'),
  })
  .transform((data) => ({
    ...data,
    newPhone: removeDDIFromAutoInsert(parseDigits(data.newPhone)),
    confirmNewPhone: removeDDIFromAutoInsert(parseDigits(data.confirmNewPhone)),
  }))
  .superRefine((data, ctx) => {
    const newPhoneError = isValidPhone(data.newPhone);
    if (newPhoneError) {
      ctx.addIssue({
        path: ['newPhone'],
        code: z.ZodIssueCode.custom,
        message: newPhoneError,
      });
    }

    const confirmNewPhoneError = isValidPhone(data.confirmNewPhone);
    if (confirmNewPhoneError) {
      ctx.addIssue({
        path: ['confirmNewPhone'],
        code: z.ZodIssueCode.custom,
        message: confirmNewPhoneError,
      });
    }

    if (data.newPhone !== data.confirmNewPhone) {
      ctx.addIssue({
        path: ['confirmNewPhone'],
        code: z.ZodIssueCode.custom,
        message: 'Confirmação deve ser igual ao novo telefone',
      });
    }
  });

export type RecoveryPhoneFormData = z.infer<typeof recoveryPhoneSchema>;
